function currency(number) {
  let formattedNumber = parseFloat(number).toFixed(2);
  formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return "$" + formattedNumber;
}

document.addEventListener("DOMContentLoaded", function () {
  const classes = {
    visuallyHidden: "visually-hidden",
  };

  const selectors = {
    addUpsell: "[data-add-upsell]",
  };

  const sizeQuantitiesElement = document.querySelector(".size-quantities");
  const hiddenQuantitySelector = document.querySelector(".js-qty__num");
  const hiddenTotalLength = document.getElementById("total-length");

  const sizeQuantities = () => {
    const sizeQuantitiesInputs = sizeQuantitiesElement.querySelectorAll(
      'input[type="radio"]'
    );
    const compareAtPrice = document.querySelector("[data-compare-price]");
    const productPrice = document.querySelector("[data-product-price]");
    const sizeString = sizeQuantitiesInputs[0].dataset?.size;
    let unit;
    if (sizeString.includes("x")) {
      const parts = sizeString.split("x");
      unit = Number(parts[1].replace(/[^\d.]/g, ""));
    } else {
      unit = Number(sizeString.replace(/[^\d.]/g, ""));
    }
    sizeQuantitiesInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        hiddenQuantitySelector.value = e.target.value;
        const totalLength = `${e.target.value * unit}m`;
        // hiddenTotalLength.value = totalLength;
        // hiddenTotalLength.setAttribute("value", totalLength);

        if (productPrice) {
          productPrice.innerText = currency(e.target?.dataset?.price);
        }
        if (compareAtPrice) {
          compareAtPrice.innerText = currency(e.target?.dataset?.comparePrice);
        }

        // Trigger a change event on the hidden input
        const event = new Event("change", { bubbles: true });
        hiddenTotalLength.dispatchEvent(event);
      });
    });

    console.log("total length removed....");
    // hiddenTotalLength.value = `${sizeQuantitiesInputs[0].value * unit}m`;
  };

  if (sizeQuantitiesElement) {
    sizeQuantities();
  }
  // -------------------------------------- *
  // CART PAGE - START
  // -------------------------------------- *
  if (document.body.classList.contains("template-cart")) {
    const returnToPreviousPage = document.querySelector(
      ".js-return-to-previous-page"
    );
    if (returnToPreviousPage) {
      returnToPreviousPage.classList.remove(classes.visuallyHidden);
      returnToPreviousPage.addEventListener("click", (e) => {
        e.preventDefault();
        window.history.back();
      });
    }
  }
});
